import { render, staticRenderFns } from "./editConfig.vue?vue&type=template&id=939618f8&"
import script from "./editConfig.vue?vue&type=script&lang=js&"
export * from "./editConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports